import MaterialIconsReact from "material-icons-react";
import styles from './StationSelection.module.css';
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { rudderStackTrackEvent } from "../plugins/analytics";

function StationSelection() {
    const {availableLocations, selectedLocation, setSelectedLocation, currentFactory, user} = useContext(UserContext);
    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
        const lsStation = JSON.parse(localStorage.getItem('seletedStation'));
        if (!availableLocations || availableLocations.length === 0) {
          if (lsStation) {
            setSelectedLocation(lsStation);
          }
        } else {
          if (!lsStation || (lsStation && lsStation.station !==  availableLocations[0].station)) {
            localStorage.setItem('seletedStation', JSON.stringify(availableLocations[0]));
            setSelectedLocation(availableLocations[0]);
          }
        }
    }, [availableLocations])

    const updateTitleMenu = (locationObj) => {
        localStorage.setItem('seletedStation', JSON.stringify(locationObj));
        setSelectedLocation(locationObj);
        rudderStackTrackEvent(
          "tars:on_station_select",
          {
            user_id: `TARS${user.id}`,
            email: user.email,
            action: "select",
            factory: currentFactory.item_code,
            station: locationObj.location
          }
        );
      }

    return (
        <>
            {selectedLocation?.location && <div className={styles.titleDropdown + ' ft-20'} onClick={() => setOpenMenu(!openMenu)}>
                {selectedLocation?.location}
                {openMenu ? <MaterialIconsReact icon='expand_less' size={20} color={'#666666'}></MaterialIconsReact>: <></>}
                {openMenu ? <></> : <MaterialIconsReact icon='expand_more' size={20} color={'#666666'}></MaterialIconsReact>}
                {openMenu && <ul className={styles.dropdown}>
                    {
                    availableLocations.map((locationObj, index) => {
                        return <li key={index} className={selectedLocation.location === locationObj.location ? styles.selected : ''} onClick={() => updateTitleMenu(locationObj)}>{locationObj.location}</li>
                    })
                    }
                </ul>}
            </div>}
        </>
    );
}

export default StationSelection;
